export default {"src":"/_next/static/media/whypod-icon4.37be84df.svg","height":49,"width":42};